module.exports = __webpack_public_path__ + "static/media/predvol_no_zoom.84aa0c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/predvol_no_zoom.png
// module id = 96
// module chunks = 0